<script lang="ts">
  import { PUBLIC_S3_STATIC_FILES_URL } from '$env/static/public';

  import type { ArtAsset } from '@entities/art-asset';

  export let digitalOriginalData: ArtAsset['digital_original'] | null = null;
</script>

<article>
  <strong class="mb-4 block text-base">Digital original details</strong>

  <ul class="flex w-full flex-col gap-2 text-base">
    <li class="flex items-center justify-between">
      <span class="flex-0.4 text-default-700 dark:text-default-500"> Format </span>

      <div class="flex-0.7">
        <span class="font-semibold">Digital Original Standard</span>
      </div>
    </li>

    {#if digitalOriginalData?.mpx}
      <li class="flex items-center justify-between">
        <span class="flex-0.4 text-default-700 dark:text-default-500"> Resolution </span>

        <div class="flex-0.7">
          <span class="font-semibold">{digitalOriginalData.mpx} MPX</span>
        </div>
      </li>
    {/if}

    <li class="flex items-center justify-between">
      <span class="flex-0.4 text-default-700 dark:text-default-500">Color depth</span>

      <p class="flex-0.7 flex gap-2 font-semibold">
        48 bit

        <span>
          <img
            src="{PUBLIC_S3_STATIC_FILES_URL}rainbow-icon_3x.png"
            class="mr-1 inline-block h-[18px] w-[18px] align-text-top"
            alt="Rainbow icon"
            loading="lazy"
          />

          281 Trillion Colors
        </span>
      </p>
    </li>

    {#if digitalOriginalData?.exif?.FileSize}
      <li class="flex items-center">
        <p class="flex-0.4 text-default-700 dark:text-default-500">Original file size</p>

        <span class="flex-0.7 font-semibold">
          {digitalOriginalData.exif.FileSize}
          {digitalOriginalData.exif?.FileType || ''} File
        </span>
      </li>
    {/if}
  </ul>
</article>
